function fillup_form(params) {

    //fillup_form({
    //    data: '{}',
    //    container: modal,
    //    disablefields: true,
    //    values: [{
    //        element: 'txtAccountInitials', //element id
    //        elementtpye: 'text', //elementtpye [text,dropdown,checkbox,radiobutton]
    //        data: 'lname', //datakey
    //        datatype: 'text', //data type [text,currency,number,date]
    //        callback: function(data){} //custom function for field
    //    }
    //    ]
    //});

    let data;

    //add option for function
    if (typeof params.data == "function") {
        data = params.data();
    } else {
        data = params.data;
    }

    let container = params.container;
    let values = params.values;
    let disablefields = params.disablefields;
    let placeholder = params.placeholder !== undefined && params.placeholder !== null ? params.placeholder : '';
    let withplaceholder = params.withplaceholder;

    for (let i = 0; i < values.length; i++) {
        let _element = container.find('#' + values[i].element);
        let _elementtype = values[i].elementtpye;
        let _data = values[i].data;
        let _datatype = values[i].datatype;
        let _callback = values[i].callback;
        

        if (_element !== undefined) {
            switch (_elementtype) {
                case 'label':
                    if (_data !== null) {

                        switch (_datatype) {
                            case 'currency':
                                _data = formatToCurrency(_data)
                                break;
                            case 'number':
                                _data = formatToNumber(_data)
                                break;
                            case 'date':
                                _data = convertDateMMDDYYYY(_data)
                                break;
                            default:
                                if (_data !== undefined && _data !== '' && _data !== null) {
                                    _data = _data;

                                } else {
                                    if (withplaceholder) {
                                        _data = placeholder;
                                    }
                                }

                                break;
                        }
                        _element.text(_data);

                        if (_callback !== undefined) {
                            values[i].callback(_data, _element);
                        }
                    } else {

                    }
                    break;
                case 'text':
                    if (_data !== null) {
                        switch (_datatype) {
                            case 'currency':
                                _data = formatToCurrency(_data)
                                break;
                            case 'number':
                                _data = formatToNumber(_data)
                                break;
                            case 'date':
                                _data = convertDateMMDDYYYY(_data)
                                break;
                            default:
                                _data = _data;
                                break;
                        }
                        _element.val(_data);

                        if (disablefields) {
                            _element.prop('readonly', true);
                        }

                        if (_callback !== undefined) {
                            values[i].callback(_data, _element);
                        }
                    }
                    break;
                case 'dropdown':
                    if (_data !== null) {
                        switch (_datatype) {
                            case 'text':
                                $(_element).selectpicker('val', _data.toUpperCase());
                                break;
                            case 'number':
                                $(_element).selectpicker('val', _data);
                                break;

                            default:

                                break;
                        }
                    }
                    break;
                case 'checkbox':
                    if (_data !== null) {

                        _element.prop('checked', _data);

                    }
                    break;
                case 'radiobutton':
                    if (_data !== null) {




                      
                    }
                    break;
                default:
                    if (_data !== null) {
                        switch (_datatype) {
                            case 'currency':
                                _data = formatToCurrency(_data)
                                break;
                            case 'number':
                                _data = formatToNumber(_data)
                                break;
                            case 'date':
                                _data = convertDateMMDDYYYY(_data)
                                break;
                            default:
                                _data = _data;
                                break;
                        }
                        _element.val(_data);
                        _element.prop('readonly', true);
                    }
                    break;
            }
        } else {
            console.log('element not found');
        }
    }
}

function fillupformbyname(params = {
    data: null,
    container: null,
    dateFields: null,
    currencyFields: null,
    timefields: null,
    selectFields: null,
    numberFields: null,
    placeholder: 'Not Specified'
}) {

    //fillupformbyname({
    //    data: '{}',
    //    container: modal,
    //    dateFields: {},
    //    currencyFields: {},
    //    timefields: {},
    //    selectFields: {},
    //    numberFields: {},
    //});

    const keys = Object.keys(params.data);
    const values = Object.values(params.data);
    const container = params.container;

    for (let i = 0; i < keys.length; i++) {
        let elInput = container.find("[name='" + keys[i] + "']");
        let dataValue = values[i];
        let dataKey = keys[i];
        if (elInput.is('textarea')) {
            elInput.val(dataValue);
        } else if(elInput.is(':checkbox')) {
            elInput.prop('checked', dataValue);
        } else if (elInput.is(':radio')) {
            container.find("[name='" + dataKey + "'][value='" + dataValue + "']").prop('checked', true);
        } else if (elInput.tagName === "DIV") {
            if (dataValue === '' || dataValue === undefined || dataValue === null) {
                elInput.html(params.placeholder);
            } else {
                elInput.html(dataValue);
            }
        } else {
            elInput.val(dataValue);
        }

        for (let sKey in params.dateFields) {
            if (sKey === dataKey) {
                if (elInput.is('div')) {
                    elInput.html(convertDateMMDDYYYY(dataValue));
                } else {
                    if (dataValue !== null && dataValue !== undefined) {
                        elInput.val(convertDateMMDDYYYY(dataValue));
                        elInput.datepicker('update');
                    }
                }
            }
        }

        for (let sKey in params.currencyFields) {
            if (sKey === dataKey) {
                if (elInput.is('div')) {
                    elInput.html(formatToCurrency(dataValue));
                } else {
                    if (dataValue !== null && dataValue !== undefined) {
                        elInput.val(formatToCurrency(dataValue));
                    }
                }
            }
        }

        if (params.numberFields !== null && params.numberFields !== undefined) {
            params.numberFields.forEach(function (key) {
                if (key === dataKey) {
                    if (elInput.tagName = "DIV") {
                        elInput.html(formatToNumber(dataValue));
                    } else {
                        if (dataValue !== null && dataValue !== undefined) {
                            elInput.val(formatToNumber(dataValue));
                        }
                    }
                }
            });
        }

        for (let sKey in params.selectFields) {
            if (sKey === dataKey) {
                let elInput = container.find("[name='" + params.selectFields[sKey] + "']");
                if (dataValue !== null && dataValue !== undefined) {
                    elInput.selectpicker('val', dataValue).selectpicker('refresh');
                }
            }
        }
    }

}

function fillUpForm(data, container, dateFields = {}, currencyFields = {}, timefields = {}, selectFields = {}, numberFields = {}) {
    const keys = Object.keys(data);
    const values = Object.values(data);
    
    for (let i = 0; i < keys.length; i++) {
        if (container.find("[name='" + keys[i] + "']").is('textarea')) {
            container.find("textarea[name='" + keys[i] + "']").val(values[i]);
        } else if (container.find("[name='" + keys[i] + "']").is(':checkbox')) {
            container.find("input[name='" + keys[i] + "']").prop('checked', values[i]);
        } else if (container.find("[name='" + keys[i] + "']").is(':radio')) {
            container.find("input[name='" + keys[i] + "'][value='" + values[i] + "']").prop('checked', true);
        } else {
            container.find("input[name='" + keys[i] + "']").val(values[i]);
        }

        for (let key in dateFields) {
            if (key === keys[i]) {
                container.find('#' + dateFields[key]).val(convertDateMMDDYYYY(values[i]));
                container.find('#' + dateFields[key]).datepicker('update');
                break;
            }
        }

        for (let ckey in currencyFields) {
            if (ckey === keys[i]) {
                container.find('#' + currencyFields[ckey]).val(formatToCurrency(values[i]));
                break;
            }
        }

        for (let ckey in numberFields) {
            if (ckey === keys[i]) {
                container.find('#' + numberFields[ckey]).val(formatToNumber(values[i]));
                break;
            }
        }

        for (let sKey in selectFields) {
            if (sKey === keys[i]) {
                if (container.find('#' + selectFields[sKey]).attr("multiple")) {
                    switch (keys[i]) {
                        case 'membertype':
                        case 'roomcoverage':
                            container.find('#' + selectFields[sKey]).selectpicker('val', values[i].split('')).selectpicker('refresh');
                            break;
                        case 'claimserviceindex':
                            container.find('#' + selectFields[sKey]).selectpicker('val', values[i].split('_')).selectpicker('refresh');
                            break;
                    }
                } else {
                    container.find('#' + selectFields[sKey]).selectpicker('val', values[i]).selectpicker('refresh');
                }
                break;
            }
        }
    }
}

